const state = () => ({
  overlay: false,
  dialogNotification: {
    status: false,
    action: null,
    message: ''
  }
})

const getters = {
  overlay: (state) => state.overlay,
  dialogNotification: (state) => state.dialogNotification,
}

const mutations = {
  TOGGLE_OVERLAY: (state, condition) => {
    state.overlay = condition
  },
  createDialogNotification: (state, data) => {
    state.dialogNotification.status = true
    state.dialogNotification.action = data.action
    state.dialogNotification.message = data.message
  },
  closeDialogNotification: (state) => {
    state.dialogNotification.status = false,
    state.dialogNotification.action = null,
    state.dialogNotification.message = ''
  },
}

export default {
  state, mutations, getters
}
